import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Fragment } from "react";
import { useState } from "react";
import Modal from "react-responsive-modal";
import { useParams } from "react-router-dom";
import WellnessService from "services/WellnessService";
import { useDispatch } from "react-redux";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import * as timelineActions from "reteamStore/actions";

export default ({ onClose, triviaId }) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const params = useParams();
  const dispatch = useDispatch();
	const { allTimelinePost } = useTeamActionContext();

  const closeSurvey = () => {
    setLoading(true);
    WellnessService.deleteIndividualTriviaQuestions(params.teamId, triviaId)
      .then(() => {
        setLoading(false);
        setOpen(false);
        onClose(true);
      })
      .catch(() => setLoading(false));


      dispatch(timelineActions.clearAll());
      allTimelinePost();
  };

  return (
    <Fragment>
      <FontAwesomeIcon
        icon={faTrash}
        onClick={() => setOpen(true)}
        style={{ cursor: "pointer", margin: "0px 20px" }}
      />
      <Modal
        center
        open={open}
        closeOnEsc={false}
        closeOnOverlayClick={false}
        styles={{
          modal: {
            maxWidth: "30%",
            width: "30%",
            borderRadius: "10px",
          },
        }}
        onClose={() => setOpen(false)}
      >
        <div className="p-3">
          <h5>
            <strong>Are you sure?</strong>
          </h5>
          <h6 className="mt-2">You want to delete this Trivia.</h6>
          <div className="mt-2 d-flex justify-content-end">
            <button
              disabled={loading}
              onClick={closeSurvey}
              className="btn btn-danger"
            >
              Yes
            </button>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};
